export class AiSnippet {
  id: number;
  aiKnowledgeType: number;
  conversationId: string;
  score: number;
  snippetText: string;
}
